<template>
  <div>
    <my-head></my-head>
    <div class="information minH">
      <div class="crumbs">
        首页 > 关于我们 >
        <span style="color: #1d2129">信息公开</span>
      </div>
      <div class="flex-left">
        <div class="left">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              :title="item.title"
              :name="item.name"
              v-for="(item, index) in datas"
              :key="index"
            >
              <div
                class="labe flex-left-center"
                v-for="(n, i) in item.nav"
                :key="i"
                @click="openNav(n)"
              >
                {{ n.head }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="right">
          <div class="rtitle flex-center">{{ rContent.head }}</div>
          <div v-html="rContent.content" class="c_content"></div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5", "6", "7"], //左侧展开
      rContent: "", // 右侧内容
      // 页面数据
      datas: [
        {
          title: "发展历程",
          name: "1",
          nav: [
            {
              head: "历史沿革",
              content: `<p>上海知识产权交易中心有限公司承载平台国内知识产权交易及相关服务功能。上海知识产权交易中心有限公司经上海市政府批准，于2017年1月13日揭牌成立。遵循专业化、市场化、国际化的原则，上海知识产权交易中心有限公司以知识产权交易、专业服务和智库研发的平台功能建设为目标，围绕专利、技术秘密、版权、商标权、集成电路布图设计专有权等开展知识产权交易业务，及相对应的资本和权益类业务，提供知识产权交易定价、挂牌上市、交易鉴证、结算清算、托管登记、项目融资、政策咨询等一门式服务，以及知识产权相关的投资并购服务，推动智力成果转移转化和产业化落地。</p>`,
            },
            { 
              head: "荣誉资质",
              content: `<div>2024:</div>
                <div>上海市总工会颁发的“工人先锋号”（2024）</div>
                <div>上海市知识产权培训基地（2024）</div>
                <div>上海知识产权交易中心有限公司荣获“2023年度上海现代服务业联合会优秀活动奖”（2024）</div>
                <div>上海知识产权交易中心科技成果转化创新生态“共建合作伙伴”（2024）</div>
                <div>2025:</div>
                <div>上海市知识产权交易中心“2024年度优秀会员奖”（2025）</div>`
            },
          ],
        },
        {
          title: "信息公开",
          name: "2",
          nav: [
            {
              head: "企业概况",
              content: `<div>企业名称：上海知识产权交易中心有限公司</div>
                        <div>注册资本：10000万元人民币</div>
                        <div>公司章程：</div>
                        <div>企业类型：有限责任公司（国有独资）</div>
                        <div>企业规模：中小型企业</div>
                        <div>门户网站：https://www.shsipe.com/</div>
                        <div>公司地址：上海市浦东新区环科路999弄15号楼</div>
                        <div>联系方式：021-50633728；传真：021-50630639；互联网联系方式：https://www.shsipe.com/</div>
                        <div>邮政编码：201210 </div>
                        <div>经营范围：为专利、商标、版权、技术秘密、集成电路布图设计等交易提供场所及配套服务。【依法须经批准的项目，经相关部门批准后方可开展经营活动】</div>`,
            },
            {
              head: "组织机构",
              content: `<img style="width:100%;" src="${require("../../assets/organization2.png")}"></img>`,
            },
            {
              head: "分支机构",
              content: `<p>分公司（营业部）网点：上海知识产权交易中心（南部分中心），地址：上海市闵行区沪闵路1391号6号楼201室</p>`,
            },
            { head: "企业文化" },
          ],
        },
        {
          title: "企业领导",
          name: "3",
          nav: [
            {
              head: "企业领导",
              content: `<div>潘&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;熙  上海知识产权交易中心有限公司董事长</div>
                        <div>汤金林  上海知识产权交易中心有限公司总经理</div>`,
            },
            {
              head: "人事任免",
              content: `<div>（一）任职</div>
                        <div>2022年8月，潘熙同志任上海知识产权交易中心有限公司总经理。</div>
                        <div>2023年8月，潘熙同志任上海知识产权交易中心有限公司董事长。</div>
                        <div>2023年8月，汤金林同志任上海知识产权交易中心有限公司总经理。</div>
                        <div>（二）免职</div>
                        <div>2022年8月，免去支伯平同志的上海知识产权交易中心有限公司总经理职务。</div>
                        <div>2023年8月，免去潘熙同志的上海知识产权交易中心有限公司总经理职务。</div>`,
            },
            {
              head: "招聘信息",
              content: ``,
            },
          ],
        },
        {
          title: "社会责任",
          name: "4",
          nav: [{ head: "社会责任报告" }, { head: "突发事件处置" }],
        },
        {
          title: "主要财务状况",
          name: "5",
          nav: [{ head: "财务情况" }],
        },
        {
          title: "企业重大事项",
          name: "6",
          nav: [
            { head: "投资信息" },
            { head: "改革重组" },
            { head: "产权交易信息" },
            { head: "不动产租赁信息" },
          ],
        },
        {
          title: "招标信息",
          name: "7",
          nav: [{ head: "招标公告" }],
        },
      ],
    };
  },
  methods: {
    // 点击左侧nav打开最有内容
    openNav(n) {
      this.rContent = n;
    },
    // 获取人事招聘列表
    getList() {
      let data = {
        page: 0,
        size: 9999,
      };
      getRequest({ url: "/api/v1/career", data }).then((res) => {
        let wzUrl = window.location.href;
        let dzUrl = wzUrl.split("#")[0];
        res.data.forEach((item) => {
          this.datas[2].nav[2].content += `<a class="flex-between list_col" href="${dzUrl}#/recruit?id=${
            item.id
          }">
          <div>${item.title}</div>
          <div>${this.$moment(item.createAt).format("YYYY-MM-DD")}</div>
          </a>`;
        });
      });
    },
  },
  mounted() {
    this.rContent = this.datas[0].nav[0];
    this.getList();
    if (this.$route.query.in1)
      this.rContent =
        this.datas[this.$route.query.in1].nav[this.$route.query.in2 || 0];
  },
};
</script>

<style lang="scss">
.information {
  width: 80%;
  margin: 24px auto 60px;
  .right {
    flex: 1;
    .list_col {
      color: #333;
      border-bottom: #cccccc dashed 1px;
      margin-bottom: 10px;
      padding-bottom: 10px;
    }
    .rtitle {
      font-size: 26px;
      border-bottom: #888888 solid 1px;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
    .c_content {
      line-height: 2em;
      font-size: 16px;
      p {
        text-indent: 2em;
      }
    }
  }
  .left {
    width: 260px;
    border: #ebeef5 solid 1px;
    padding: 0 15px;
    margin-right: 20px;
    .el-collapse-item__content {
      padding-bottom: 0;
      font-size: 14px;
    }
    .el-collapse-item__header {
      font-size: 14px;
    }
    .el-collapse-item__header {
      height: 40px;
      line-height: 40px;
    }
    .labe {
      height: 40px;
      padding-left: 15px;
      cursor: pointer;
    }
  }
}
</style>
